<div *ngIf="this.itemEnvelope?.Document?.Item?.Body != ''" style="margin-top: 12px; margin-bottom: 12px; margin-left: 20px; margin-right: 20px;">
    <div [innerHTML]="replaceThemeNameToken(this.itemEnvelope?.Document?.Item?.Body)"></div>
</div>
<div style="border: 0px solid fuchsia;">
    <div class="info-box">
        <button mat-button (click)="appService.showSubscribeDialog()" class="standout-mat-button">
            <img src="https://lutzangeles.blob.core.windows.net/app/LutzAngelino_v4_{{ appService.themeService.currentThemeName }}.png" class="button-img-small" alt="icon" />
            SUBSCRIBE
        </button>
        <button mat-button (click)="share()" aria-label="Share this site" class="share-button" style="height: 48px;">
            <mat-icon>share</mat-icon>
            SHARE
        </button>
    </div>
</div>
<br *ngIf="appService.screenSize == 1" />
<br *ngIf="appService.screenSize == 1" />
<br *ngIf="appService.screenSize == 1" />
<br />
<br />
<br />
